import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {UnitModel} from '../../../unit/unit.model';

@Injectable({
  providedIn: 'root'
})
export class UnitUnifiedSearchService {

  constructor(
    private http: HttpClient
  ) { }

  public getUnits(searchString: string, projectId: number | null = null) {
    let params = new HttpParams()
      .set('fields', 'id,name,hw_id,plate_number,warehouse_number')
      .set('per-page', '20')
      .set('UnitSearch[ownedByExecutor]', 'false')
      .set('UnitSearch[unified_search_field]', searchString);

    if (projectId) {
      params = params.set('UnitSearch[project_id]', projectId.toString(10));
    }
    return this.http.get<UnitModel[]>(
      environment.apiBasepoint + 'unit',
      {params: params, observe: 'body'}
    );
  }
}
